/* eslint-disable */
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { KeeniconComponent } from "@shared/keenicon/keenicon.component";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  selector: "app-resident-actions-cell",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (!isPennedBottom) {
      <div>
        @if (this.isAction.edit) {
          <button
            (click)="onHandleEdit($event)"
            [title]="'BUTTON.EDIT' | translate"
            class="edit mx-1"
          >
            <span>
              <app-keenicon name="notepad-edit" class="fs-2 text-primary" />
            </span>
          </button>
        }
        @if (this.isAction.delete) {
          <button
            (click)="onHandleDelete($event)"
            [title]="'BUTTON.DELETE' | translate"
            class="trash mx-1"
          >
            <span>
              <app-keenicon name="trash" class="fs-2 text-danger" />
            </span>
          </button>
        }
        @if (this.isAction.link) {
          <button
            (click)="onGoLink($event)"
            [title]="'BUTTON.LINK' | translate"
            class="link mx-1"
          >
            <span>
              <app-keenicon name="double-right" class="fs-2 text-success" />
            </span>
          </button>
        }
      </div>
    }
  `,
  styles: [
    `
      :host {
        width: 100%;
        display: inline-flex;
        justify-content: center;
      }
    `,
  ],
  standalone: true,
  imports: [KeeniconComponent, TranslateModule],
})
export class ResidentActionsComponent<T> implements ICellRendererAngularComp {
  params: any;
  isPennedBottom: undefined | string;
  isAction = {
    delete: true,
    edit: true,
    link: true,
  };

  agInit(params: any): void {
    this.params = params;
    this.isPennedBottom = this.params?.node?.rowPinned;
    this.isAction.delete = typeof params["handleDelete"] === "function";
    this.isAction.edit = typeof params["handleEdit"] === "function";
    this.isAction.link = typeof params["handleGoLink"] === "function";
  }

  onGoLink(event: Event) {
    event.stopPropagation();
    if (this.params.handleGoLink) this.params.handleGoLink(this.params.data);
  }

  onHandleEdit(event: Event) {
    event.stopPropagation();
    if (this.params.handleEdit) this.params.handleEdit(this.params.data);
  }

  onHandleDelete(event: Event) {
    event.stopPropagation();
    if (this.params.handleDelete) this.params.handleDelete(this.params.data);
  }

  refresh() {
    return true;
  }
}
